import React, { useMemo } from "react";
import { useOrganisation } from "../../../networking/organisation.hooks";
import { t } from "i18next";
import SelectPopover from "../../Core/SelectPopover/SelectPopover";
import styled from "styled-components";

interface Props {
	onChange: (pool: string) => any;
	value?: string;
}

const PoolFilter: React.FC<Props> = ({ onChange, value }) => {
	const { data: organisation } = useOrganisation();

	const hasPools = !!organisation?.pools?.length;

	const poolOptions = useMemo(() => {
		if (organisation?.pools) {
			return [{ name: t("ALL"), key: "" }, ...organisation.pools];
		}
		return [];
	}, [organisation, t]);

	if (!hasPools) {
		return null;
	}

	return (
		<Styles>
			<SelectPopover<{ key: string; name: string }>
				label={t("POOL")}
				popoverWidth={300}
				value={value}
				onSelect={(val) => onChange(val.key)}
				options={poolOptions}
				popoverPosition="right"
				className="select-pool"
				getLabelFromOption={(o) => o?.name || ""}
				getValueFromOption={(o) => o?.key || ""}
				getOptionFromValue={(val, opts) => opts.find((o) => o.key === val)}
			/>
		</Styles>
	);
};

export default PoolFilter;

const Styles = styled.div`
	.select-pool {
		min-width: 220px;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
`;
